import React from 'react';
import {connect} from 'react-redux'
import { withRouter} from 'react-router-dom'

import {AddStockItemButton, DeleteStockItemButton} from './utils'
import {
  deletingStock, deletingStockSuccess, deletingStockFailure, resetDeletingStock,
  fetchingStocks, fetchedStocks, fetchStocksError} from '../../redux/actions/stockactions'
import axios from 'axios'
import {getToken} from '../../storage'
import {API_BASE_URL} from '../../constants'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import SuccessMsg from '../../utils/successmsg'

class StockItemList extends React.Component {
  constructor(props) {
    super(props)
    this.handleSelectRow = this.handleSelectRow.bind(this)
    this.handleClickRow = this.handleClickRow.bind(this)
    this.handleOnSelectAll = this.handleOnSelectAll.bind(this)
    this.deleteStockItems = this.deleteStockItems.bind(this)
    this.fetchStocks = this.fetchStocks.bind(this)
    this.unitFormat = this.unitFormat.bind(this)
    this.fetchStocks()
    document.title = "Stock Items List"
    this.state = {selectedRows: []}
  }

  unitFormat(cell, row, so) {
    if(cell != null) {
      console.log(cell);
      return cell.compiled_unit_name
    }

  }

  fetchStocks() {
    this.props.dispatch(fetchingStocks())
    axios({
      url: '/list_stock_items/',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    }).then((response)=>{

      if(response.status === 200) {
          this.props.dispatch(fetchedStocks(response.data.stock_items))
      }
    }).catch((err)=>{
      console.log(err);
      this.props.dispatch(fetchStocksError(err.response.data))
    })
  }

  handleClickRow(row) {

    this.props.history.push('/stock_items/edit/'+row.id)
  }
  handleSelectRow(row, isSelected, e) {

    let currentSelection = this.state.selectedRows
    let newSelection
    if(isSelected) {
      newSelection = currentSelection.concat(row)
    }
    else {
      newSelection= currentSelection.filter(obj => row.id !== obj.id)
    }
    this.setState({selectedRows: newSelection})
  }
  handleOnSelectAll(isSelected, rows) {
    if(isSelected) {
      this.setState({selectedRows: rows})
    }
    else {
      this.setState({selectedRows: []})
    }
  }

  deleteStockItems() {
    this.props.dispatch(deletingStock())
    axios({
      url: '/delete_stock_items/',
      method: 'POST',
      baseURL: API_BASE_URL,
      data: this.state.selectedRows,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      }
    }).then((response)=> {
      if(response.status === 200) {
        this.props.dispatch(deletingStockSuccess(this.state.selectedRows))
        this.setState({selectedRows: []})
        this.props.dispatch(resetDeletingStock())
      }
    }).catch((err)=> {
        this.props.dispatch(deletingStockFailure(err.response.data))

    })
  }

  render() {

    const stock = this.props.stock
    let ss
    if(this.state.showSuccess) {
      ss = <SuccessMsg />
    }

    return (<div>
      <section className="medium">
      <AddStockItemButton />
        <DeleteStockItemButton selectedRows={this.state.selectedRows} handleDelete = {this.deleteStockItems} stock={stock} />
        {ss}
      </section>
    <div className="panel panel-default">

      <BootstrapTable data={stock.stock_items} striped hover
          options={{defaultSortName: 'id', defaultSortOrder: 'desc', onRowClick:this.handleClickRow}}
          selectRow = {{mode:'checkbox', bgColor:'#A9B6B7', onSelect:this.handleSelectRow, onSelectAll: this.handleOnSelectAll}}
          >
          <TableHeaderColumn isKey dataField='id' dataSort={true}>ID</TableHeaderColumn>
          <TableHeaderColumn dataField='name'  dataSort={true}>Name</TableHeaderColumn>
          <TableHeaderColumn dataField='hsn_code'>HSN Code</TableHeaderColumn>
          <TableHeaderColumn dataField='available_from'>Available From</TableHeaderColumn>
          <TableHeaderColumn dataField='quantity'>Quantity</TableHeaderColumn>
          <TableHeaderColumn dataField='unit' dataFormat={this.unitFormat}>Unit</TableHeaderColumn>
          <TableHeaderColumn dataField='igst_pct'>IGST</TableHeaderColumn>
        </BootstrapTable>
    </div>


    </div>)
  }
}
const mapStateToProps = (state) => {
  return {
    stock: state.stockReducer
  }
}

export default connect(mapStateToProps)(withRouter(StockItemList))



// WEBPACK FOOTER //
// ./src/components/stockitem/stockitemlist.js